import * as React from 'react';
import Button from '@material-ui/core/Button';
import {
  Dialog, DialogActions, DialogContent, DialogTitle,
  Typography,
} from '@material-ui/core';
import type { IRestartScanDialogProps } from './MassReceiveInterfaces';

const RestartScanDialog: React.FC<IRestartScanDialogProps> = (
  { showModal, onClose },
) => {
  const handleCancel = () => {
    onClose();
  };

  const handleRestart = () => {
    onClose(true);
  };

  return (
    <Dialog onClose={handleCancel} open={showModal}>
      <DialogTitle>
        <Typography variant="overline">
          {'ERROR DURING SCANNING PROCESS'}
        </Typography>
        <Typography variant="h5" id="dialog-header">{'Start scanning process over'}</Typography>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="textSecondary">
          {'In order to make sure all of the necessary repair items are added into the system, we need you to re-start the scanning process of this mass receiving transfer.'}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button id="cancel-scanning-button" color="secondary" variant="text" onClick={handleCancel}>{'CANCEL'}</Button>
        <Button id="restart-scanning-button" color="primary" variant="contained" onClick={handleRestart}>{'START SCANNING PROCESS'}</Button>
      </DialogActions>
    </Dialog>
  );
};

export default RestartScanDialog;
